import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import MoveToInboxOutlinedIcon from '@mui/icons-material/MoveToInboxOutlined';
import OutboxOutlinedIcon from '@mui/icons-material/OutboxOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import KeyboardReturnOutlinedIcon from '@mui/icons-material/KeyboardReturnOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import type { NavEntry, NavGroup, NavItem } from '@/navigation/navItems';
import { Perm } from '@/auth/permissions';
import { Modules } from '@/core/modules/moduleKeys';

const item = (label: string, path: string, icon: NavItem['icon'], comingSoon?: boolean): NavItem =>
  ({ label, path, icon, module: Modules.Stock, permission: Perm.Stock.View, ...(comingSoon ? { comingSoon } : {}) });

/**
 * The stock module's navigation: one collapsible Stock menu with the areas a stores office works in
 * as sub-menus. Each area's page carries its leaves as tabs. Shown only where the organisation has
 * the module on, which in turn needs the accounting module.
 */
export const stockNavEntries: NavEntry[] = [
  item('Overview', '/stock', Inventory2OutlinedIcon),
  {
    kind: 'group', key: 'stock-master', label: 'Master Data', icon: CategoryOutlinedIcon,
    items: [
      item('Items', '/stock/master/items', CategoryOutlinedIcon),
      item('Stores & Bins', '/stock/master/stores', WarehouseOutlinedIcon),
    ],
  },
  {
    kind: 'group', key: 'stock-receiving', label: 'Receiving', icon: MoveToInboxOutlinedIcon,
    items: [
      item('Receipts', '/stock/receiving/receipts', MoveToInboxOutlinedIcon),
      item('Supplier Returns', '/stock/receiving/supplier-returns', KeyboardReturnOutlinedIcon),
      item('Landed Costs', '/stock/receiving/landed-costs', ReceiptLongOutlinedIcon),
    ],
  },
  {
    kind: 'group', key: 'stock-issues', label: 'Issues', icon: OutboxOutlinedIcon,
    items: [
      item('Requisitions', '/stock/issues/requisitions', AssignmentOutlinedIcon),
      item('Issue Vouchers', '/stock/issues/vouchers', OutboxOutlinedIcon),
    ],
  },
  {
    kind: 'group', key: 'stock-transfers', label: 'Transfers', icon: LocalShippingOutlinedIcon,
    items: [
      item('Transfers', '/stock/transfers/transfers', LocalShippingOutlinedIcon),
      item('Differences', '/stock/transfers/discrepancies', ReportProblemOutlinedIcon),
      item('Controlled Register', '/stock/transfers/controlled-register', ShieldOutlinedIcon),
    ],
  },
  {
    kind: 'group', key: 'stock-counts', label: 'Counts & Adjustments', icon: FactCheckOutlinedIcon,
    items: [
      item('Stock Counts', '/stock/counts/counts', FactCheckOutlinedIcon),
      item('Adjustments', '/stock/adjustments/adjustments', TuneOutlinedIcon),
      item('Reorder', '/stock/adjustments/reorder', ReplayOutlinedIcon),
      item('Supply', '/stock/adjustments/supply', InsightsOutlinedIcon),
      item('Recalls & Status', '/stock/adjustments/recalls', ReportProblemOutlinedIcon),
    ],
  },
  item('Reports', '/stock/reports', SummarizeOutlinedIcon),
  item('Stock Settings', '/stock/settings', SettingsOutlinedIcon),
];

export const stockNavGroup: NavGroup = {
  kind: 'group', key: 'stock', label: 'Stock', icon: Inventory2OutlinedIcon, items: stockNavEntries,
};
